import { Avatar, AvatarFallback, AvatarImage } from '@quadminds/mindkit';
import { Plug } from 'lucide-react';
import { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface ActiveConnectonProps {
    id: string;
    className?: string;
    name: string;
    description: string;
    image: string;
}
const ActiveConnection: FC<PropsWithChildren<ActiveConnectonProps>> = ({
    id,
    className,
    name,
    description,
    image,
    children,
}) => {
    return (
        <div key={id} className={twMerge('flex px-4 py-[18px] h-[70px] rounded-[8px] w-full bg-[#263238]', className)}>
            <Avatar className="h-[34px] w-[34px] rounded-[4px]">
                <AvatarImage
                    className="h-[34px] w-[34px] rounded-[4px] object-contain"
                    src={image}
                    alt="connection Avatar"
                />
                <AvatarFallback className="!rounded">
                    <Plug />
                </AvatarFallback>
            </Avatar>
            <div className="flex flex-col justify-center items-start ml-2">
                <p className="font-poppins font-medium text-[14px] leading-[18px] text-white">{name}</p>
                <p className="font-roboto font-normal text-[12px] leading-[16px] text-[#B0BEC5]">{description}</p>
            </div>
            <div className="flex items-center justify-end ml-auto gap-4">
                {/* <Button>Subir Archivos</Button>
                <Button variant="secondary">Desactivar</Button> */}
                {children}
            </div>
        </div>
    );
};

export default ActiveConnection;
